// extracted by css-extract-rspack-plugin
export default {"container":"CopilotMessageBubble-module__container__oW7JC","text":"CopilotMessageBubble-module__text__ADukm","loadingText":"CopilotMessageBubble-module__loadingText__fh2Yq"};